import React, {useState, useEffect} from 'react';
import StyleButton from './StyleButton';


export default function BlockToolbar({editorState, onToggle}) {

    const selection = editorState.getSelection();

    const currentType = editorState
        .getCurrentContent()
        .getBlockForKey(selection.getStartKey())
        .getType();

    return <div className="toolbar">
        {BLOCK_TYPES.map(([type, label]) =>
            <StyleButton
                key={type}
                type={type}
                label={label}
                onToggle={type => onToggle(type)}
                active={type === currentType}
            />
        )}
    </div>;
};


const BLOCK_TYPES = [
    ['header-two', 'H2'],
    ['header-three', 'H3'],
    ['header-four', 'H4'],
    ['header-five', 'H5'],
    // ['blockquote', 'Blockquote'],
    ['unordered-list-item', 'UL'],
    ['ordered-list-item', 'OL'],
    // ['code-block', 'Code Block'],
];
